import { checkPermission } from '@/router/guards.ts'

const RedemptionModule = () => import('./RedemptionModule.vue')
const RedemptionIndex = () => import('./views/RedemptionIndex.vue')

export const redemptionRoute = {
  path: '/redemptions',
  name: 'redemption',
  component: RedemptionModule,
  meta: {
    title: 'Redemptions',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'redemptions-index',
      component: RedemptionIndex,
      // meta: {
      //   permission: 'redemption.view',
      // },
      // beforeEnter: checkPermission('redemption.view'),
    },
  ],
}
